import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogCompleteGuide from "../pages/blog/litbuy-spreadsheet-complete-guide/page";
import BlogReview from "../pages/blog/litbuy-spreadsheet-review/page";
import BlogHowToUse from "../pages/blog/how-to-use-litbuy-spreadsheet/page";
import BlogTemplates from "../pages/blog/best-litbuy-spreadsheet-templates/page";
import BlogVsGoogleSheets from "../pages/blog/litbuy-spreadsheet-vs-google-sheets/page";
import BlogFeatures from "../pages/blog/top-features-litbuy-spreadsheet/page";
import BlogMistakes from "../pages/blog/common-mistakes-litbuy-spreadsheet/page";
import BlogSetup from "../pages/blog/litbuy-spreadsheet-setup-guide/page";
import BlogAdvanced from "../pages/blog/advanced-tips-litbuy-spreadsheet/page";
import BlogAlternatives from "../pages/blog/best-alternatives-litbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/litbuy-spreadsheet-complete-guide",
    element: <BlogCompleteGuide />,
  },
  {
    path: "/blog/litbuy-spreadsheet-review",
    element: <BlogReview />,
  },
  {
    path: "/blog/how-to-use-litbuy-spreadsheet",
    element: <BlogHowToUse />,
  },
  {
    path: "/blog/best-litbuy-spreadsheet-templates",
    element: <BlogTemplates />,
  },
  {
    path: "/blog/litbuy-spreadsheet-vs-google-sheets",
    element: <BlogVsGoogleSheets />,
  },
  {
    path: "/blog/top-features-litbuy-spreadsheet",
    element: <BlogFeatures />,
  },
  {
    path: "/blog/common-mistakes-litbuy-spreadsheet",
    element: <BlogMistakes />,
  },
  {
    path: "/blog/litbuy-spreadsheet-setup-guide",
    element: <BlogSetup />,
  },
  {
    path: "/blog/advanced-tips-litbuy-spreadsheet",
    element: <BlogAdvanced />,
  },
  {
    path: "/blog/best-alternatives-litbuy-spreadsheet",
    element: <BlogAlternatives />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;